function omit(object) {
  let keysToOmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const clone = Object.assign({}, object);
  for (const key of keysToOmit) {
    if (key in clone) {
      delete clone[key];
    }
  }
  return clone;
}
export { omit };